// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.4);
  height: 400px;
  flex-direction: column;
  margin: 0 auto;
  width: 80%;
  font-size: 22px;
}

ion-icon {
  font-size: 55px;
}

.inner-message {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 992px) {
  .content {
    min-width: 992px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/general components/no-content/no-content.component.scss","webpack://./src/components/general%20components/no-content/no-content.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EAEA,UAAA;EAEA,eAAA;ACDF;;ADIA;EACE,eAAA;ACDF;;ADKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ACFF;;ADOA;EACE;IACE,gBAAA;ECJF;AACF","sourcesContent":[".content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgb(0, 0, 0, 0.4);\n  height: 400px;\n  flex-direction: column;\n  margin: 0 auto;\n\n  width: 80%;\n\n  font-size: 22px;\n}\n\nion-icon {\n  font-size: 55px;\n}\n\n\n.inner-message{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n\n@media screen and (min-width: 992px) {\n  .content {\n    min-width: 992px;\n  }\n}\n",".content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgba(0, 0, 0, 0.4);\n  height: 400px;\n  flex-direction: column;\n  margin: 0 auto;\n  width: 80%;\n  font-size: 22px;\n}\n\nion-icon {\n  font-size: 55px;\n}\n\n.inner-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media screen and (min-width: 992px) {\n  .content {\n    min-width: 992px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
